import DataPrivacyMessageStep from './DataPrivacyMessageStep';

export default DataPrivacyMessageStep;
